import React, { FC } from "react";
import { Button } from "src/components/Button";

interface Props {
  color: string;
  isActive: boolean;
  onClick: VoidFunction;
}
export const ColorButton: FC<Props> = ({ isActive, onClick, color }) => (
  <Button
    type="button"
    className="relative rounded-full !brightness-100 overflow-hidden outline outline-2 outline-offset-2 outline-transparent"
    style={isActive ? { outlineColor: color } : {}}
    onClick={onClick}
  >
    <span className="w-4 h-4" style={{ backgroundColor: color }} />
  </Button>
);
